export function _toPlainDate(value) {
    if (value === null || typeof value === 'undefined' || value === false) {
        return null;
    }

    if (value instanceof Date) {
        return value;
    }

    if (value && typeof value.toJSDate === 'function') {
        return value.toJSDate();
    }

    if (value && typeof value.toDate === 'function') {
        return value.toDate();
    }

    if (typeof value === 'string' || typeof value === 'number') {
        var parsed = new Date(value);

        return isNaN(parsed.getTime()) ? null : parsed;
    }

    return null;
}

export function _toLegacyBootstrapDateFormat(format) {
    if (!format || typeof format !== 'string') {
        return undefined;
    }

    return format
        .replace(/YYYY/g, 'yyyy')
        .replace(/YY/g, 'yy')
        .replace(/DD/g, 'dd')
        .replace(/\bhh\b/g, 'HH')
        .replace(/\bA\b/g, 'T')
        .replace(/\ba\b/g, 't');
}

export function _normalizeColorValue(color) {
    if (!color || typeof color !== 'string') {
        return '';
    }

    if (color[0] === '#') {
        return color;
    }

    if (/^[0-9a-fA-F]{6}$/.test(color)) {
        return '#' + color;
    }

    return '';
}

export function getUrlVars() {
    var vars = {};
    window.location.href.replace(
        /[?&]+([^=&]+)=([^&]*)/gi,
        function (m, key, value) {
            vars[key] = value;
        }
    );
    return vars;
}

export function formatCurrency(value) {
    return parseFloat(value).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

/**
 * A dollar amount for display: '$25.00', '-$25.00', '$0.00'.
 *
 * The JS counterpart of format_currency() in app/Helpers/display_elements_helper.php, and
 * deliberately the same rendering: the sign goes BEFORE the symbol. Every caller used to
 * write '$' + formatCurrency(value), which put the symbol on the wrong side of the minus
 * and printed a core-return credit as '$-25.00' (#1176). A negative is a real value on
 * these pages as of #792, so use this wherever a rendered amount could be one.
 *
 * The sign comes off the amount ROUNDED to the rendered precision, so -0.001 prints
 * '$0.00' rather than '-$0.00'. A value that is not a number at all prints '$0.00', which
 * is what parseFloat().toFixed(2) already degraded to.
 */
export function formatCurrencyWithSymbol(value) {
    var amount = parseFloat(value);

    if (isNaN(amount)) {
        amount = 0;
    }

    // toFixed() rounds, so read the sign off the rounded figure and not off `amount`
    var rounded = parseFloat(amount.toFixed(2));
    var sign = rounded < 0 ? '-' : '';

    return sign + '$' + formatCurrency(Math.abs(rounded));
}

/**
 * Is there an amount here at all - set, numeric, and not zero?
 *
 * The core-price renderers gated on `parseFloat(value) > 0`, which is the right answer for
 * every no-charge shape the server sends and the wrong one for a credit (#1176). `!= 0` is
 * not the fix: parseFloat('') is NaN, and NaN != 0 is TRUE, so a blank core price would
 * start rendering as '$0.00' on every card.
 *
 * So: null, undefined, '', '   ', '0', 0, '0.00', 0.0 and 'n/a' are all false - the row
 * stays hidden, exactly as it does today. -25, '-25.00' and 25 are true.
 */
export function hasNonZeroAmount(value) {
    var amount = parseFloat(value);

    return !isNaN(amount) && amount !== 0;
}

/**
 * Writes a recalculated checkout total back to the hidden dropship_order_subtotal input.
 *
 * order/view.inc renders that input from the server-side $po_total as the order stood on page
 * load, and Shipping::get_shipping_estimates() adds the carrier quote to it to produce the
 * "order total" the summary panel shows. Every client-side recalculation therefore has to write
 * the new figure back, or a quantity change leaves the estimate quoted against a total the user
 * is no longer looking at. The real order total is still recomputed server-side from the stored
 * line items on submit - this value only feeds the estimate.
 *
 * Written unformatted on purpose: the receiving end is floatval(), and floatval('1,234.56') is 1.
 * No-op where the input is absent, so the order pages that share these recalculations are safe.
 */
export function syncCheckoutSubtotalInput(total) {
    var $input = $('input[name="dropship_order_subtotal"]');
    if (!$input.length) {
        return;
    }
    $input.val((parseFloat(total) || 0).toFixed(2));
}

export function spinnerHtml(text) {
    var icon = '<i class="fa fa-circle-o-notch fa-spin"></i>';
    return text ? icon + ' ' + text : icon;
}

export function appendRel(youtubeURI) {
    if (typeof youtubeURI !== 'string' || youtubeURI.length === 0) {
        return youtubeURI;
    }

    if (youtubeURI.indexOf('?') !== -1) {
        return youtubeURI + '&rel=0';
    }

    return youtubeURI + '?rel=0';
}

/**
 * Resolve a "#elementId" string to a DOM node. IDs may contain "." and other
 * characters that break jQuery/CSS selectors (e.g. $("#id.with-dots")).
 */
export function getElementByHashId(hashId) {
    if (!hashId || typeof hashId !== 'string' || hashId.charAt(0) !== '#') {
        return null;
    }
    var id = hashId.slice(1);
    if (!id) {
        return null;
    }
    return document.getElementById(id);
}

// CONCEPT: the one HTML escaper. Anything server-, ERP- or feed-derived that is concatenated into
// a string handed to .html() goes through this first. Three near-identical copies existed
// (meilisearch-helpers' escapeAutocompleteHtml, checkout-inventory's escapeHtml, and nothing at
// all in product-browse/quick-order/ajax-form, which is where issues #129, #133, #134 and #135
// came from) - so this is the shared one and the others delegate to it.
// USE: '<td>' + escapeHtml(label) + '</td>'
// Escapes the single quote as well, so a value is also safe inside a single-quoted attribute.
export function escapeHtml(value) {
    if (value === null || typeof value === 'undefined') {
        return '';
    }

    return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

/**
 * Returns url only if it is safe to place in an href or src. Anything that is not
 * http(s) - javascript:, data:, vbscript:, a protocol-relative //host - returns ''.
 * Relative paths are allowed.
 */
export function safeUrl(url) {
    if (typeof url !== 'string') {
        return '';
    }

    var trimmed = url.trim();

    if (trimmed === '' || trimmed.indexOf('//') === 0) {
        return '';
    }

    // a scheme is everything before the first colon, if that comes before any / ? #
    var colon = trimmed.indexOf(':');
    if (colon !== -1) {
        var beforeColon = trimmed.slice(0, colon);
        if (!/[/?#]/.test(beforeColon)) {
            if (!/^https?$/i.test(beforeColon)) {
                return '';
            }
        }
    }

    return trimmed;
}
